"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "@/components/auth/Auth";
import Link from "next/link";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { ApiProfileProxyActionType } from "@/generated/models/ApiProfileProxyActionType";
export default function UserPageIdentityHeaderCICRateStats(t0) {
  const $ = _c(34);
  const {
    isTooltip,
    profile,
    minMaxValues,
    heroAvailableCredit
  } = t0;
  const {
    activeProfileProxy
  } = useContext(AuthContext);
  let t1;
  if ($[0] !== activeProfileProxy?.actions) {
    t1 = () => {
      const proxy = activeProfileProxy?.actions.find(_temp);
      if (!proxy) {
        return null;
      }
      return Math.max(0, (proxy.credit_amount ?? 0) - (proxy.credit_spent ?? 0));
    };
    $[0] = activeProfileProxy?.actions;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getProxyAvailableCredit = t1;
  const [proxyAvailableCredit, setProxyAvailableCredit] = useState(getProxyAvailableCredit());
  let t2;
  if ($[2] !== getProxyAvailableCredit) {
    t2 = () => setProxyAvailableCredit(getProxyAvailableCredit());
    $[2] = getProxyAvailableCredit;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== activeProfileProxy) {
    t3 = [activeProfileProxy];
    $[4] = activeProfileProxy;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== activeProfileProxy || $[7] !== heroAvailableCredit || $[8] !== proxyAvailableCredit) {
    t4 = () => {
      if (!activeProfileProxy) {
        return heroAvailableCredit;
      }
      return Math.abs(heroAvailableCredit) < Math.abs(proxyAvailableCredit ?? 0) ? heroAvailableCredit : proxyAvailableCredit ?? 0;
    };
    $[6] = activeProfileProxy;
    $[7] = heroAvailableCredit;
    $[8] = proxyAvailableCredit;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const getAvailableCredit = t4;
  let t5;
  if ($[10] !== getAvailableCredit) {
    t5 = getAvailableCredit();
    $[10] = getAvailableCredit;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const [availableCredit, setAvailableCredit] = useState(t5);
  let t6;
  if ($[12] !== getAvailableCredit) {
    t6 = () => setAvailableCredit(getAvailableCredit());
    $[12] = getAvailableCredit;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== heroAvailableCredit || $[15] !== proxyAvailableCredit) {
    t7 = [heroAvailableCredit, proxyAvailableCredit];
    $[14] = heroAvailableCredit;
    $[15] = proxyAvailableCredit;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  useEffect(t6, t7);
  const t8 = `${isTooltip ? "tw-text-sm" : "tw-text-base"} tw-flex tw-flex-col tw-space-y-1`;
  let t9;
  if ($[17] !== activeProfileProxy) {
    t9 = !!activeProfileProxy && <span className="tw-block tw-text-iron-200 tw-font-normal"><span>You are acting as proxy for:</span><span className="tw-ml-1 tw-font-semibold tw-text-iron-100"><Link href={`/${activeProfileProxy.created_by.handle}`}>{activeProfileProxy.created_by.handle}</Link></span></span>;
    $[17] = activeProfileProxy;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span>Your available NIC:</span>;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== availableCredit) {
    t11 = formatNumberWithCommas(availableCredit);
    $[20] = availableCredit;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11) {
    t12 = <span className="tw-block tw-text-iron-200 tw-font-normal">{t10}<span className="tw-ml-1 tw-font-semibold tw-text-iron-100">{t11}</span></span>;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== activeProfileProxy || $[25] !== minMaxValues.max || $[26] !== minMaxValues.min || $[27] !== profile.handle) {
    t13 = activeProfileProxy ? <><span className="tw-block tw-text-iron-200 tw-font-normal"><span>Your max NIC Rating to {profile.handle}:</span><span className="tw-ml-1 tw-font-semibold tw-text-iron-100">{formatNumberWithCommas(minMaxValues.max)}</span></span><span className="tw-block tw-text-iron-200 tw-font-normal"><span>Your min NIC Rating to {profile.handle}:</span><span className="tw-ml-1 tw-font-semibold tw-text-iron-100">{formatNumberWithCommas(minMaxValues.min)}</span></span></> : <span className="tw-block tw-text-iron-200 tw-font-normal tw-break-all"><span>Your max/min NIC Rating to {profile.handle}:</span><span className="tw-ml-1 tw-font-semibold tw-text-iron-100">+/- {formatNumberWithCommas(minMaxValues.max)}</span></span>;
    $[24] = activeProfileProxy;
    $[25] = minMaxValues.max;
    $[26] = minMaxValues.min;
    $[27] = profile.handle;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t12 || $[30] !== t13 || $[31] !== t8 || $[32] !== t9) {
    t14 = <div className={t8}>{t9}{t12}{t13}</div>;
    $[29] = t12;
    $[30] = t13;
    $[31] = t8;
    $[32] = t9;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  return t14;
}
function _temp(action) {
  return action.action_type === ApiProfileProxyActionType.AllocateCic;
}